import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { ICourseDetailsResponse } from "../../Interfaces/ResponsesData";
import { Notify } from "../../Handlers/Notifications";
import { TermPeriod } from "../../Models/Course";

export class CoursesListVM extends InterActive{
    private selectedCourse:string = ''
    private coursesList:{id:string , course:string}[] = []
    private courseDetails:ICourseDetailsResponse = { id: '' , periods:[]}

    public get SelectedCourse():string { return this.selectedCourse}
    public get CoursesList():{id:string , course:string }[] { return this.coursesList }
    public get CourseDetails():ICourseDetailsResponse { return this.courseDetails}

    public set SelectedCourse(value:string){ this.selectedCourse = value; this.update() }
    
    public getCourses(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.allCourses()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.coursesList = response.data.data
                                if(response.data.data.length>0){
                                    this.SelectedCourse = this.coursesList[0].id 
                                }
                                this.Messege=''
                            }else{
                                if(response.data.error_code === 'D0001') this.Messege = response.data.messege
                                else  Notify({type:'danger' , title:'1حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت '})
                            }
                        }else  Notify({type:'danger' , title:'2حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت '})
                    }
                }catch{
                    Notify({type:'danger' , title:'3حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت '})
                }
            }
        )
    }

    public load(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getCourseDetails(this.selectedCourse)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.courseDetails ={id:response.data.data.id , periods:response.data.data.periods} 
                                this.update()
                            }else Notify({type:'danger' , title:'خطأ غير معروف'  , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }else Notify({type:'danger' , title:'خطأ غير معروف'  , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{ Notify({type:'danger' , title:'خطأ غير معروف'  , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
            }
        )
    }

    public async deleteCourse(id:string ){
        this.removeCourse(id)
        try{
            const response = await ApiRequest.deleteItem(id, 'الكورس')
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(!response.data.status){
                        Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
    }

    public removeCourse(id:string ){
        this.loading(
            async()=>{
                this.coursesList = this.coursesList.filter(a=>a.id!==id)
                this.update()   
            }
        )
     
    }
    public async addCourse(value:string){
        try{
            const response = await ApiRequest.addItem(value, 'الكورس')
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.pushCourse(response.data.data.id , response.data.data.value)
                    }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
    }
    private pushCourse(id:string , course:string ){
        const item = this.coursesList.find(a=>a.id === id)
        if(!item){
            this.coursesList = [...this.coursesList,{id:id,course:course}] 
        } ;
        this.update()
    }
    public removeItem(id:string){
        this.courseDetails.periods = this.courseDetails.periods.filter(a=>a.id!==id)
        this.update()
    }
    public pushItem(item:TermPeriod){
        this.courseDetails.periods.push(item)
        this.update()
    }

}